/**
 *  @class
 *  @function Timeline
 */

if (!customElements.get('time-line')) {
	class Timeline extends HTMLElement {
		constructor() {
			super();
			this.id = this.dataset.id;
			this.scroller = this.querySelector('.timeline--scroll-container');
			this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
			this.scrollSet = false;
			this.items = this.querySelectorAll('.timeline--slide');
			this.labels = this.querySelectorAll('.timeline--scroll-pagination li');

			if (this.animations_enabled) {
				this.scrollSet = gsap.quickSetter('#time-line-progress-' + this.id, "scaleX");
			}
		}
		connectedCallback() {
			const _this = this;
			if (this.animations_enabled) {
				_this.scroller.addEventListener('scroll', () => this.onScroll());
			}

			_this.labels.forEach((item, i) => {
				_this.setLabelPosition(item);
			});
		}
		setLabelPosition(item) {
			let arr = Array.prototype.slice.call(this.labels),
				i = arr.indexOf(item),
				itemWidth = this.items[i].offsetWidth;
			item.style.flex = '0 0 ' + itemWidth + 'px';
		}
		onScroll() {
			let scrollLeft = this.scroller.scrollLeft,
				scrollerWidth = this.scroller.offsetWidth,
				contentWidth = this.scroller.querySelector('.timeline--scroll-inner').offsetWidth,
				scrollPercent = (scrollLeft) / (contentWidth - scrollerWidth);

			this.scrollSet(scrollPercent);
		}
	}
	customElements.define('time-line', Timeline);
}

document.addEventListener('DOMContentLoaded', function() {
	const timeline = document.querySelector('time-line');
	const prevButton = document.querySelector('.timeline-nav-prev');
	const nextButton = document.querySelector('.timeline-nav-next');
	const container = timeline.querySelector('.timeline--scroll-container');
	const slides = Array.from(container.querySelectorAll('.timeline--slide'));
	const paginationItems = Array.from(document.querySelectorAll('.timeline--scroll-pagination button'));
	let currentIndex = 0;

	let isProgrammaticScroll = false;

	function scrollToSlide(index, shouldFocus = false) {
	  if (index < 0) index = slides.length - 1;
	  if (index >= slides.length) index = 0;
	  currentIndex = index;

	  const slideWidth = slides[0].offsetWidth;
	  const containerWidth = container.offsetWidth;
	  const offset = slideWidth * currentIndex - (containerWidth - slideWidth) / 2;

	  isProgrammaticScroll = true;

	  container.scrollTo({
		left: offset,
		behavior: 'smooth'
	  });

	  updateActiveStates();

	  if (shouldFocus) {
		const label = paginationItems[currentIndex];
		if (label) label.focus({ preventScroll: true });
	  }
	}

	function updateActiveStates() {
	  slides.forEach((slide, i) => {
		const isActive = i === currentIndex;
		slide.classList.toggle('active', isActive);
		if (isActive) {
		  slide.removeAttribute('inert');
		} else {
		  slide.setAttribute('inert', '');
		}
	  });

	  paginationItems.forEach((item, i) => {
		const isActive = i === currentIndex;
		item.parentElement.classList.toggle('active', isActive);
		item.setAttribute('aria-current', isActive ? 'true' : 'false');
		if (isActive) {
		  item.setAttribute('aria-describedby', 'timeline-content-' + timeline.dataset.id + '-' + (i + 1));
		} else {
		  item.removeAttribute('aria-describedby');
		}
	  });
	}

	function onScroll() {
	  if (isProgrammaticScroll) return;
	  const slideWidth = slides[0].offsetWidth;
	  const containerWidth = container.offsetWidth;
	  const scrollPosition = container.scrollLeft;
	  const index = Math.max(0, Math.min(slides.length - 1,
		Math.round((scrollPosition + (containerWidth - slideWidth) / 2) / slideWidth)
	  ));
	  if (index !== currentIndex) {
		currentIndex = index;
		updateActiveStates();
	  }
	}

	container.addEventListener('scrollend', () => {
	  isProgrammaticScroll = false;
	}, { passive: true });

	paginationItems.forEach((item, i) => {
	  item.addEventListener('click', () => {
		scrollToSlide(i, true);
	  });
	});

	prevButton.addEventListener('click', () => {
	  scrollToSlide(currentIndex - 1, true);
	});

	nextButton.addEventListener('click', () => {
	  scrollToSlide(currentIndex + 1, true);
	});

	container.addEventListener('scroll', onScroll);
	scrollToSlide(currentIndex);
});
  function isMobile() {
	return window.innerWidth <= 768;
  }

  function scrollToSlide(index) {
	if (index < 0) index = slides.length - 1;
	if (index >= slides.length) index = 0;
	currentIndex = index;

	const slideWidth = slides[0].offsetWidth;
	const containerWidth = container.offsetWidth;
	const offset = slideWidth * currentIndex - (containerWidth - slideWidth) / 2;

	container.scrollTo({
	  left: offset,
	  behavior: 'smooth'
	});

	updateActiveStates();

	if (isMobile()) {
	  centerActiveLabel();
	}
}

function centerActiveLabel() {
	const activeLabel = paginationItems[currentIndex].querySelector('.timeline--label');
	const labelParent = paginationItems[currentIndex];
	const parentWidth = labelParent.offsetWidth;
	const scrollContainer = document.querySelector('.timeline--scroll-pagination ul');
	const containerWidth = scrollContainer.offsetWidth;
  
	const offset = labelParent.offsetLeft - (containerWidth - parentWidth) / 2;
  
	scrollContainer.scrollTo({
		left: offset,
		behavior: 'smooth'
	});
}

function updateActiveStates() {
	slides.forEach((slide, i) => {
		slide.classList.toggle('active', i === currentIndex);
	});

	paginationItems.forEach((item, i) => {
	  const isActive = i === currentIndex;
	  item.classList.toggle('active', isActive);
	  item.setAttribute('aria-current', isActive ? 'true' : 'false');
	  const label = item.querySelector('.timeline--label');
	  if (label) {
		label.classList.toggle('active', isActive);
	  }
	});
  
	if (isMobile()) {
	  centerActiveLabel();
	}
}
